import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class MakeService {
  constructor(private http: HttpClient) {}

  getMake(): Observable<any> {
    const paramData = {
      deviceId: 'postman'
    };

    // console.log('-----Get Make List-----------');
    return this.http.post(
      `${GlobalVariable.BASE_API_URL}/vehicle/getVehicle`,
      paramData
    );
  }
}
